import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { hasActivePredicate } from '../settings-predicates';
import { mapSearchRowToDraftSummary } from './drafts-search-row-mapper';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
const EMPTY = [];
const PAGE_LIMIT = 200;
export const useDraftsAiSearchResults = function useDraftsAiSearchResults() {
    let { enabled = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref;
    const { api } = useStoreActions();
    const filter = useDraftsAiSearchStore((s)=>s.filter);
    const setError = useDraftsAiSearchStore((s)=>s.setError);
    const isActive = enabled && filter != null && hasActivePredicate(filter);
    const { data, isFetching, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.DraftsAiSearchResults,
            filter
        ],
        queryFn: (param)=>{
            let { signal } = param;
            if (filter == null) throw new Error('drafts AI-search query enabled without a filter');
            return api.draft.search({
                filter,
                limit: PAGE_LIMIT,
                signal
            });
        },
        enabled: isActive,
        staleTime: 0,
        cacheTime: 0,
        onError: (err)=>{
            var _err_response;
            const status = err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status;
            setError(status === 404 ? 'feature_disabled' : 'search_failed');
        },
        onSuccess: ()=>setError(null)
    });
    const entries = data === null || data === void 0 ? void 0 : data.entries;
    const drafts = Array.isArray(entries) ? entries.map(mapSearchRowToDraftSummary) : EMPTY;
    return {
        drafts,
        isActive,
        isFetching,
        isLoading,
        refresh,
        renderedCount: drafts.length,
        totalMatchCount: (_ref = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _ref !== void 0 ? _ref : 0
    };
};
